import { int64, Timestamp } from '@fullstory/proto/google/protobuf';
import { JourneyDetail } from '@fullstory/proto/fs/services/dx-objects';
import { Scope } from '@fullstory/proto/fs/api/search';
import { JourneyMapSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { mockAuditMetadata } from '../shared';
import { CustomIdent, PageViewIdent, SeenVisibility } from '@fullstory/proto/fs/api/segment';

export const MOCK_JOURNEY_MAP_ID = '12';

const date = Timestamp.now();
export const mockJourneyDetail: JourneyDetail = {
  journey: {
    journeyMap: {
      id: MOCK_JOURNEY_MAP_ID,
      name: 'First Journey Map',
      description: 'this is a description',
      journeyMap: {
        pivot: [
          {
            primary: {
              visitedPage: {
                any: {},
              },
            },
            deps: [],
          },
        ],
        pivotSequence: null,
        syntheticTypes: [],
        interactions: [{ primary: { visitedPage: { any: {} } }, deps: [] }],
        eventIdent: {
          pageView: {
            builtInField: PageViewIdent.PageViewField.FIELD_PAGE_DEF_ID,
            next: [],
          },
          custom: {
            builtInField: CustomIdent.CustomField.FIELD_EVENT_NAME,
            next: [],
          },
          // Named elements for journeys was added later, so these are `null` for historical testing purposes
          // TODO(jb): Update tests to assume all `eventIdent` have been migrated. Including in all the fixtures in
          // packages/journeys-ui/src/components/JourneyMapDetailForm/__tests__/fixtures.ts
          click: null,
          seen: null,
          change: null,
          definedEvent: null,
        },
        constraints: {
          inSameSession: true,
          timeRange: {
            startTime: 'NOW/DAY-6DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
        },
        latestPivot: false,
        collapseRepeated: true,
      },
      journeyMapSettings: {
        segment: [{ segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL }],
        direction: JourneyMapSettings.Direction.DIRECTION_FORWARD,
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: date,
};

export const mockJourneyDetailWithHiddenPageEvents: JourneyDetail = {
  journey: {
    journeyMap: {
      id: MOCK_JOURNEY_MAP_ID,
      name: 'First Journey Map',
      description: 'this is a description',
      journeyMap: {
        pivot: [
          {
            primary: {
              visitedPage: {
                any: {},
              },
            },
            deps: [],
          },
        ],
        pivotSequence: null,
        syntheticTypes: [],
        interactions: [
          {
            primary: {
              visitedPage: {
                notEquals: { value: [int64.fromNumber(10)], spec: [] },
              },
            },
            deps: [],
          },
        ],
        eventIdent: {
          pageView: {
            builtInField: PageViewIdent.PageViewField.FIELD_PAGE_DEF_ID,
            next: [],
          },
          custom: {
            builtInField: CustomIdent.CustomField.FIELD_EVENT_NAME,
            next: [],
          },
          // Named elements for journeys was added later, so these are `null` for historical testing purposes
          // TODO(jb): Update tests to assume all `eventIdent` have been migrated. Including in all the fixtures in
          // packages/journeys-ui/src/components/JourneyMapDetailForm/__tests__/fixtures.ts
          click: null,
          seen: null,
          change: null,
          definedEvent: null,
        },
        constraints: {
          inSameSession: true,
          timeRange: {
            startTime: 'NOW/DAY-6DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
        },
        latestPivot: false,
        collapseRepeated: true,
      },
      journeyMapSettings: {
        segment: [{ segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL }],
        direction: JourneyMapSettings.Direction.DIRECTION_FORWARD,
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: date,
};

export const mockJourneyDetailWithHiddenNamedElements: JourneyDetail = {
  journey: {
    journeyMap: {
      id: MOCK_JOURNEY_MAP_ID,
      name: 'First Journey Map',
      description: 'this is a description',
      journeyMap: {
        pivot: [
          {
            primary: {
              click: {
                withSetHistoricalElementId: {},
              },
            },
            deps: [
              {
                element: {
                  withoutHistoricalElementId: {
                    value: ['Named Element'],
                    spec: [],
                  },
                },
              },
            ],
          },
          {
            primary: {
              seen: {
                withSetHistoricalElementId: {},
              },
            },
            deps: [
              {
                seenVisibility: {
                  equals: {
                    value: SeenVisibility.SEEN_VISIBILITY_IN_VIEWPORT,
                  },
                },
              },
              {
                element: {
                  withoutHistoricalElementId: {
                    value: ['Named Element'],
                    spec: [],
                  },
                },
              },
            ],
          },
        ],
        pivotSequence: null,
        syntheticTypes: [],
        interactions: [
          {
            primary: {
              click: {
                withSetHistoricalElementId: {},
              },
            },
            deps: [
              {
                element: {
                  withoutHistoricalElementId: {
                    value: ['Named Element'],
                    spec: [],
                  },
                },
              },
            ],
          },
          {
            primary: {
              seen: {
                withSetHistoricalElementId: {},
              },
            },
            deps: [
              {
                seenVisibility: {
                  equals: {
                    value: SeenVisibility.SEEN_VISIBILITY_IN_VIEWPORT,
                  },
                },
              },
              {
                element: {
                  withoutHistoricalElementId: {
                    value: ['Named Element'],
                    spec: [],
                  },
                },
              },
            ],
          },
        ],
        eventIdent: {
          pageView: {
            builtInField: PageViewIdent.PageViewField.FIELD_PAGE_DEF_ID,
            next: [],
          },
          custom: {
            builtInField: CustomIdent.CustomField.FIELD_EVENT_NAME,
            next: [],
          },
          // Named elements for journeys was added later, so these are `null` for historical testing purposes
          // TODO(jb): Update tests to assume all `eventIdent` have been migrated. Including in all the fixtures in
          // packages/journeys-ui/src/components/JourneyMapDetailForm/__tests__/fixtures.ts
          click: null,
          seen: null,
          change: null,
          definedEvent: null,
        },
        constraints: {
          inSameSession: true,
          timeRange: {
            startTime: 'NOW/DAY-6DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
        },
        latestPivot: false,
        collapseRepeated: true,
      },
      journeyMapSettings: {
        segment: [{ segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL }],
        direction: JourneyMapSettings.Direction.DIRECTION_FORWARD,
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: date,
};
